import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setTheme } from '../../store/slices/themeSlice'
import './Settings.css'

const themeOptions = [
  {
    id: 'samsung',
    name: 'Samsung Aurora',
    description: 'Default Samsung One UI inspired palette with balanced blues and clean surfaces.',
    preview: ['#3b82f6', '#2563eb', '#1d4ed8', '#f8fafc'],
  },
  {
    id: 'sunrise',
    name: 'Sunrise Glow',
    description: 'Warm gradient-forward palette that brings energy to dashboards and detail pages.',
    preview: ['#f97316', '#fb923c', '#fed7aa', '#fff7ed'],
  },
  {
    id: 'aurora',
    name: 'Aurora Dream',
    description: 'Vibrant violet and indigo accents designed for product marketing and analytics views.',
    preview: ['#8b5cf6', '#7c3aed', '#5b21b6', '#eef2ff'],
  },
  {
    id: 'emerald',
    name: 'Emerald Meadow',
    description: 'Rich emerald gradients ideal for growth metrics, student progress, and success states.',
    preview: ['#10b981', '#059669', '#047857', '#ecfdf5'],
  },
  {
    id: 'midnight',
    name: 'Midnight Edge',
    description: 'High-contrast dark theme designed for low-light environments and late-night sessions.',
    preview: ['#0f172a', '#1f2937', '#4f46e5', '#38bdf8'],
  },
]

const Settings = () => {
  const dispatch = useDispatch()
  const currentTheme = useSelector((state) => state.theme.current)
  const activeTheme = themeOptions.find((theme) => theme.id === currentTheme)

  const handleThemeSelect = (themeId) => {
    if (themeId !== currentTheme) {
      dispatch(setTheme(themeId))
    }
  }

  return (
    <div className="settings">
      <header className="settings__header">
        <h1>Appearance &amp; Settings</h1>
        <p>Fine-tune the visual system with curated theme token packs for the teacher console.</p>
      </header>

      <section className="settings__section">
        <div className="settings__section-head">
          <div>
            <h2>Theme Tokens</h2>
            <p>Pick a palette to instantly re-skin surfaces, typography, and interactive states.</p>
          </div>
          <span className="settings__active-theme">
            Active theme: {activeTheme ? activeTheme.name : currentTheme}
          </span>
        </div>

        <div className="theme-grid">
          {themeOptions.map((theme) => {
            const isActive = currentTheme === theme.id
            return (
              <button
                key={theme.id}
                type="button"
                className={`theme-card ${isActive ? 'theme-card--active' : ''}`}
                onClick={() => handleThemeSelect(theme.id)}
                aria-pressed={isActive}
              >
                <div className="theme-card__header">
                  <h3>{theme.name}</h3>
                  {isActive && <span className="theme-card__badge">Active</span>}
                </div>
                <p>{theme.description}</p>
                <div className="theme-card__swatches" aria-hidden="true">
                  {theme.preview.map((color) => (
                    <span
                      key={color}
                      className="theme-card__swatch"
                      style={{ backgroundColor: color }}
                    />
                  ))}
                </div>
              </button>
            )
          })}
        </div>
      </section>
    </div>
  )
}

export default Settings
